import { PaginationReturn } from '@common/types/service';
import { NewsItem } from '@news/types';
import { api } from '@services/api';

const newsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getPublicNews: builder.query<
            PaginationReturn<NewsItem>,
            {
                highlighted?: boolean;
                page?: number;
                page_size?: number;
                top_last_3_months?: boolean;
                requestCache?: RequestCache;
            }
        >({
            query: ({ requestCache, ...params }) => ({
                url: 'public/news/',
                params,
                cache: requestCache,
            }),
            providesTags: (result) => {
                if (result && result.results) {
                    return [
                        ...result.results.map(({ id }: { id: number }) => ({ type: 'News' as const, id })),
                        { type: 'News', id: 'LIST' },
                    ];
                } else {
                    return [{ type: 'News', id: 'LIST' }];
                }
            },
        }),
        getPublicNewsDetail: builder.query<NewsItem, { id: number }>({
            query: ({ id }) => `public/news/${id}/`,
            providesTags: (_, _err, { id }) => [{ type: 'News' as const, id }],
        }),
    }),
});

export const { useGetPublicNewsQuery, useGetPublicNewsDetailQuery, useLazyGetPublicNewsQuery } = newsApi;
export default newsApi;
